import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export const categoryHref = (category, child = "", topic = "", geography = "") => {
    const params = new URLSearchParams({category});
    if (child) params.set("material", child.toLowerCase());
    if (topic) params.set("topic", topic.toLowerCase());
    if (geography) params.set("geography", geography);
    return `/explore?${params}`;
};
export default function CategoryDirectory() {
    const [categories, setCategories] = useState([]);
    const [failed, setFailed] = useState(false);
    const [params] = useSearchParams();
    useEffect(() => { api.get("/directory/taxonomy").then(({data}) => setCategories(data)).catch(() => setFailed(true)); }, []);
    return <nav aria-label="Category directory" className="sdx-category-tree">
        <Link className="block p-2 text-sm text-violet-700 font-semibold" to="/explore">All categories</Link>
        {categories.map(category => <details key={category.slug} open={params.get("category") === category.slug}>
            <summary className="sdx-category-row"><span aria-hidden="true" className="sdx-category-chevron">›</span><span>{category.name}</span></summary>
            <Link className="block p-2 text-xs text-violet-700" to={categoryHref(category.slug, "", "", params.get("geography"))}>Explore {category.name}</Link>
            <div className="ml-2 pl-2 border-l space-y-1">{category.children.map(child => <div key={child.name}>
                <Link className="block p-2 text-xs rounded hover:bg-violet-50" to={categoryHref(category.slug,child.name,"",params.get("geography"))}>{child.name}</Link>
                {child.children.length > 0 && <div className="ml-3 border-l pl-2">{child.children.map(name => <Link key={name} className="block py-2 text-xs text-neutral-600 hover:text-violet-700" to={categoryHref(category.slug,child.name,name,params.get("geography"))}>{name}</Link>)}</div>}
            </div>)}</div>
        </details>)}
        {failed && <p role="alert">Directory unavailable. Reload to try again.</p>}
    </nav>;
}
